import React, { useCallback, useMemo } from 'react';
import LinearGradient from 'utils/packages/linearGradient';
import IconPlus from 'design-system/icons/IconPlus';
import { SettingsItem } from 'design-system/SettingsItem';
import FlatListItemCard from 'design-system/FlatListItemCard';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import useColorScheme from 'hooks/useColorScheme';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectSubcategoriesByParentCategoryId } from 'reducers/selectors';
import { FlatList } from 'react-native';
import SectionHeader from 'features/invest/components/SectionHeader';
import EditCategoryListVerticalRow from './EditCategoryVerticalListRow';
const keyExtractor = (item) => item.id;
const SubcategoriesList = ({ parentCategory }) => {
    const styles = useStyles(styleSet);
    const subcategories = useAppSelector((store) => selectSubcategoriesByParentCategoryId(store, parentCategory?.id));
    const renderItem = useCallback(({ item, index }) => (<FlatListItemCard index={index + 1} itemsLength={subcategories.length + 1} style={styles.listItem}>
        <EditCategoryListVerticalRow category={item} onPress={() => {
            navigation.push('CustomCategoryEdit', { category: item });
        }} showEdit/>
      </FlatListItemCard>), [styles.listItem, subcategories.length]);
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const ListHeaderComponent = useMemo(() => (<>
        <SectionHeader title="Subcategories"/>
        <FlatListItemCard index={0} itemsLength={subcategories.length + 1} style={styles.listItem}>
          <SettingsItem title="Add subcategory" onPress={() => navigation.navigateDeprecated('CreateCustomCategory', {
            parentCategory,
        })} renderIcon={() => (<LinearGradient colors={[colors.background.dark, colors.background.dark]} style={styles.addIcon}>
                <IconPlus color={colors.elements.brand}/>
              </LinearGradient>)}/>
        </FlatListItemCard>
      </>), [
        colors.background.dark,
        colors.elements.brand,
        parentCategory,
        styles.addIcon,
        styles.listItem,
        subcategories.length,
    ]);
    const colorScheme = useColorScheme();
    const baseProps = {
        scrollEnabled: false,
        data: subcategories,
        renderItem,
        keyExtractor,
        ListHeaderComponent,
        style: styles.container,
    };
    return <FlatList {...baseProps} extraData={colorScheme}/>;
};
const styleSet = createStyleSheets((colors) => ({
    listItem: {
        backgroundColor: colors.cards.onDark,
    },
    addIcon: {
        width: rem(44),
        height: rem(44),
        borderRadius: rem(44),
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: rem(16),
    },
    container: {
        flexGrow: 0,
    },
}));
export default SubcategoriesList;
